import HallSelectFormItem from "./hall-select-form-item";


const HallFormItems = {
    Select: HallSelectFormItem,
};

export default HallFormItems;